import React, { useEffect, useState } from "react";
import { Plus, Search, Trash2, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const empty = { name: "", email: "", phone: "", address: "", notes: "" };

export default function Owners() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = async () => { const { data } = await api.get("/owners", { params: q ? { q } : {} }); setItems(data); };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [q]);

  const submit = async () => {
    try {
      await api.post("/owners", form);
      toast.success("Proprietario creato"); setOpen(false); setForm(empty); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Eliminare questo proprietario?")) return;
    try { await api.delete(`/owners/${id}`); load(); toast.success("Eliminato"); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-6" data-testid="owners-page">
      <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight">Proprietari</h1>
          <p className="text-muted-foreground text-sm mt-1">Anagrafica proprietari immobiliari.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="gap-2" data-testid="new-owner-button"><Plus className="w-4 h-4" /> Nuovo proprietario</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuovo proprietario</DialogTitle></DialogHeader>
            <div className="space-y-3 py-2">
              <div><Label>Nome *</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="owner-name-input" /></div>
              <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div><Label>Telefono</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              <div><Label>Indirizzo</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
              <div><Label>Note</Label><Textarea rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button onClick={submit} disabled={!form.name} data-testid="owner-submit-button">Crea</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </header>

      <Card className="border-border/60 p-4">
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input placeholder="Cerca proprietari…" className="pl-9" value={q} onChange={(e) => setQ(e.target.value)} data-testid="owners-search" /></div>
      </Card>

      <Card className="border-border/60 overflow-hidden">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Nome</TableHead><TableHead>Email</TableHead><TableHead>Telefono</TableHead><TableHead>Indirizzo</TableHead><TableHead />
          </TableRow></TableHeader>
          <TableBody>
            {items.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-16">Nessun proprietario ancora.</TableCell></TableRow>}
            {items.map((o) => (
              <TableRow key={o.id}>
                <TableCell className="font-medium">{o.name}</TableCell>
                <TableCell className="text-sm">{o.email && <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" />{o.email}</span>}</TableCell>
                <TableCell className="text-sm">{o.phone && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" />{o.phone}</span>}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{o.address}</TableCell>
                <TableCell className="text-right"><Button variant="ghost" size="icon" onClick={() => remove(o.id)} data-testid={`del-owner-${o.id}`}><Trash2 className="w-4 h-4 text-muted-foreground" /></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
